import lodash from "lodash";
import moment from "moment";
import { checkDateRange, historyFilter } from "./HistoryUtils";

// TYPES

export const AI_DESC_HIST_UPDATE_DROPDOWN_OPEN = "AI_DESC_HIST_UPDATE_DROPDOWN_OPEN";
export const AI_DESC_HIST_UPDATE_DROPDOWN_SELECT = "AI_DESC_HIST_UPDATE_DROPDOWN_SELECT";
export const AI_DESC_HIST_UPDATE_DESC_SELECT = "AI_DESC_HIST_UPDATE_DESC_SELECT";
export const AI_DESC_HIST_UPDATE_DESC_OPEN = "AI_DESC_HIST_UPDATE_DESC_OPEN";
export const AI_DESC_HIST_UPDATE_DESC = "AI_DESC_HIST_UPDATE_DESC";
export const AI_DESC_HIST_UPDATE_DESC_EDITING = "AI_DESC_HIST_UPDATE_DESC_EDITING";
export const AI_DESC_HIST_CALL = "AI_DESC_HIST_CALL";
export const AI_DESC_HIST_HANDLE_ACTION_DESC = "AI_DESC_HIST_HANDLE_ACTION_DESC";
export const AI_DESC_HIST_UPDATE_ACTION_DESC = "AI_DESC_HIST_UPDATE_ACTION_DESC";
export const AI_DESC_HIST_UNDO_DESC = "AI_DESC_HIST_UNDO_DESC";
export const AI_DESC_HIST_FETCH = "AI_DESC_HIST_FETCH";
export const AI_DESC_HIST_DELETE = "AI_DESC_HIST_DELETE";
export const AI_DESC_HIST_CLEAR = "AI_DESC_HIST_CLEAR";

// ACTIONS

export const updateHistDdOpen = (payload) => ({
    type: AI_DESC_HIST_UPDATE_DROPDOWN_OPEN,
    payload,
});

export const updateHistDdSelect = (payload) => ({
    type: AI_DESC_HIST_UPDATE_DROPDOWN_SELECT,
    payload,
});

export const updateHistDescSelect = (payload) => ({
    type: AI_DESC_HIST_UPDATE_DESC_SELECT,
    payload,
});

export const updateHistDescOpen = (payload) => ({
    type: AI_DESC_HIST_UPDATE_DESC_OPEN,
    payload,
});

export const updateHistDesc = (payload) => ({
    type: AI_DESC_HIST_UPDATE_DESC,
    payload,
});

export const updateHistDescEditing = (payload) => ({
    type: AI_DESC_HIST_UPDATE_DESC_EDITING,
    payload,
});

export const handleHistFetch = (payload) => ({
    type: AI_DESC_HIST_FETCH,
    payload,
});

export const updateActionHistDesc = (payload) => ({
    type: AI_DESC_HIST_UPDATE_ACTION_DESC,
    payload,
});

export const handleUndoHistDesc = (payload) => ({
    type: AI_DESC_HIST_UNDO_DESC,
    payload,
});

export const clearHistoryDetails = (payload) => ({
    type: AI_DESC_HIST_CLEAR,
    payload,
});

// Actions to trigger saga generators

export const handleHistCall = (payload) => ({
    type: AI_DESC_HIST_CALL,
    payload,
});

export const handleHistAction = (payload) => ({
    type: AI_DESC_HIST_HANDLE_ACTION_DESC,
    payload,
});

export const handleHistDel = (payload) => ({
    type: AI_DESC_HIST_DELETE,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    dropDowns: {
        catergory: {
            title: "Category",
            defaultTitle: "Category",
            dropDownList: [
                { title: "All", type: "all" },
                { title: "Property description", type: "property_description" },
                { title: "E-mail", type: "email" },
                { title: "Facebook", type: "Facebook" },
                { title: "Instagram", type: "Instagram" },
                { title: "Twitter", type: "Twitter" },
                { title: "Linkedin", type: "Linkedin" },
                { title: "Agent's Bio", type: "realtor_bio" },
                { title: "Rewrite Content", type: "rewrite_paragraph" },
                { title: "Video", type: "video" },
                { title: "Flyer", type: "flyer" },
            ],
            selectedItem: "all",
            isOpen: false,
        },
        recent: {
            title: "Recent activities (All)",
            defaultTitle: "Recent activities (All)",
            dropDownList: [
                { title: "Recent activities (All)", type: "Recent activities (All)" },
                { title: "Today", type: `Today` },
                { title: "Yesterday", type: `Yesterday` },
                { title: "Last 7 days", type: `Last 7 days` },
                { title: "Last 30 days", type: `Last 30 days` },
                { title: "Last six months", type: `Last six months` },
            ],
            selectedItem: "Recent activities (All)",
            isOpen: false,
        }
    },
    allDescriptions: {
        "9-01-2023": [
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 1",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 2",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
        ],
        "17-12-2022": [
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 1",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
            {
                selectedIndex: -1,
                category: "all",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 2",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
        ],
        "16-01-2023": [
            {
                selectedIndex: -1,
                category: "email",
                title: "191-27 Pineville Lane,  email",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 2",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
        ],

        "15-01-2023": [
            {
                selectedIndex: -1,
                category: "email",
                title: "191-27 Pineville Lane,  email 1",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 2",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
        ],

        "10-01-2023": [
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 1",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
            {
                selectedIndex: -1,
                category: "property_description",
                title: "191-27 Pineville Lane,  New York  NY 11413, United States of America 2",
                numberOfDesc: 2,
                isOpen: false,
                isSelected: false,
                descs: [
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                    {
                        generatedDesc:
                            "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
                        editedDesc: "",
                        isEditing: false,
                        isEdited: false,
                        liked: null,
                        generated_at: Date.now(),
                    },
                ]

            },
        ],





    },
    filteredDescriptions: {},
    histSortedDates: [],
    delHistory: [],
    errMsg: "Please fill the required fields.",
};

const HistoryReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case AI_DESC_HIST_CLEAR: {
            return lodash.cloneDeep(INITIAL_STATE);
        }
        case AI_DESC_HIST_UPDATE_DROPDOWN_OPEN: {
            const { ddInd, isOpen } = action.payload;
            let temp_state = { ...state };
            let dds = temp_state["dropDowns"]
            dds[ddInd]["isOpen"] = isOpen
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UPDATE_DROPDOWN_SELECT: {
            const { ddInd, ddListItem } = action.payload;
            let temp_state = { ...state };
            let dds = temp_state["dropDowns"]
            dds[ddInd]["selectedItem"] = ddListItem?.type
            dds[ddInd]["title"] = ddListItem?.title
            historyFilter(temp_state)
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UPDATE_DESC_SELECT: {
            const { pastDesind, desInd, isSelected, order_id } = action.payload;
            let temp_state = { ...state };
            let pds = temp_state["filteredDescriptions"]
            if (isSelected) {
                temp_state.delHistory.push(order_id)
                pds[pastDesind][desInd]["selectedIndex"] = temp_state.delHistory.length - 1;
            } else {
                temp_state.delHistory.splice(pds[pastDesind][desInd]["selectedIndex"], 1)
                pds[pastDesind][desInd]["selectedIndex"] = -1
            }
            pds[pastDesind][desInd]["isSelected"] = isSelected
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UPDATE_DESC_OPEN: {
            const { pastDesind, desInd, isOpen } = action.payload;
            let temp_state = { ...state };
            let pds = temp_state["filteredDescriptions"]
            pds[pastDesind][desInd]["isOpen"] = isOpen
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UPDATE_DESC: {
            const { pastDesind, desInd, subDescInd, editedDesc } = action.payload;
            let temp_state = { ...state };
            let subDs = temp_state["filteredDescriptions"][pastDesind][desInd]["descriptions"][subDescInd]
            subDs["editedDesc"] = editedDesc
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_FETCH: {
            const { history } = action.payload;
            let temp_state = { ...state };
            temp_state["allDescriptions"] = history
            historyFilter(temp_state)
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UPDATE_ACTION_DESC: {
            const { pdTitle, descInd, subDescInd, actionInfo } = action.payload;
            let temp_state = { ...state };
            let subDs = temp_state["filteredDescriptions"][pdTitle][descInd]["descriptions"][subDescInd]
            Object.keys(actionInfo).forEach((actKey) => {
                subDs[actKey] = actionInfo[actKey]
            })
            subDs["isEditing"] = false
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UNDO_DESC: {
            const { pdTitle, descInd, subDescInd } = action.payload;
            let temp_state = { ...state };
            let subDs = temp_state["filteredDescriptions"][pdTitle][descInd]["descriptions"][subDescInd]
            subDs["editedDesc"] = subDs["description_generated"];
            subDs["isEditing"] = false
            return {
                ...temp_state,
            };
        }
        case AI_DESC_HIST_UPDATE_DESC_EDITING: {
            const { pastDesind, descInd, subDescInd, isEditing } = action.payload;
            let temp_state = { ...state };
            let subDs = temp_state["filteredDescriptions"][pastDesind][descInd]["descriptions"][subDescInd]
            if (subDs["description_generated"] !== subDs["editedDesc"] && subDs["editedDesc"] !== "") {
                subDs["isEdited"] = true
            } else {
                subDs["isEdited"] = false
            }
            subDs["isEditing"] = isEditing

            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default HistoryReducer;
